export default "__VITE_ASSET__xw3wqtVI__"